<script setup lang="ts">
import { AppTrashCanButton } from '@libs/ui';

interface ActivityCardHeaderProps {
  printMode: boolean;
  date?: string;
}

const props = defineProps<ActivityCardHeaderProps>();

interface ActivityCardHeaderEmits {
  (event: 'remove'): void;
}

const emit = defineEmits<ActivityCardHeaderEmits>();
</script>

<template>
  <div class="activity-card-header">
    <div class="activity-card-header-details">
      <div v-if="props.date" class="separator" />
      <p v-if="props.date" class="activity-date">{{ props.date }}</p>
    </div>
    <AppTrashCanButton
      v-if="!props.printMode"
      class="icon"
      :aria-label="$t('a11y.remove_activity')"
      @click="emit('remove')"
    />
  </div>
</template>

<style scoped lang="scss">
.activity-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  position: relative;
  width: 100%;

  .activity-card-header-details {
    display: flex;
    align-items: center;
    .title {
      all: unset;
      color: var(--color-neutral-40);
      @include font-body-m-bold;
    }

    .separator {
      width: 1px;
      height: 18px;
      background-color: var(--color-scrollbar);
      margin: 0 var(--spacing-16);
    }

    .activity-date {
      all: unset;
      color: var(--color-neutral-40);
      @include font-body-m-light;
    }
  }

  .icon {
    position: absolute;
    right: 0;
  }
}
</style>
